import { Koi } from '@ksyos/koi';

export interface ISsoAllergy {
    description: string;
    name: string;
    start: string;
}

const ssoAllergy = Koi.object({
    description: Koi.string().max(255).allow(''),
    name: Koi.string().max(255).allow(''),
    start: Koi.string().max(255).allow(''),
});

export const ssoAllergies = Koi.array().items(ssoAllergy);

export interface IAllergy {
    codeSystem: string;
    comment: string;
    displayName: string;
    endDate: string | null;
    id: string;
    startDate: string | null;
    statusCode: string;
    valueCode: string;
}

export const allergySchema = Koi.object({
    codeSystem: Koi.string().max(255).allow('', null),
    comment: Koi.string().max(255).allow('', null),
    displayName: Koi.string().max(255).allow('', null),
    endDate: Koi.koi().endDate().allow('', null),
    id: Koi.string().uuid(),
    startDate: Koi.koi().date().allow('', null),
    statusCode: Koi.string().max(255).allow('', null),
    valueCode: Koi.string().max(255).allow('', null),
});

export type IAllergies = IAllergy[];
export const allergies = Koi.array().items(allergySchema);
